<div class="delta-panel" role="dialog" aria-label="Download theme preview" aria-modal="true">
  <div class="delta-header">
    <span class="delta-title">Download Preview</span>
    <button
      type="button"
      class="delta-close-btn"
      (click)="onCancel()"
      aria-label="Close preview"
    >&#x2715;</button>
  </div>

  <!-- Mode toggle tabs -->
  <div class="delta-mode-tabs" role="tablist" aria-label="Preview mode">
    <button
      type="button"
      class="delta-tab"
      [class.active]="mode() === 'light'"
      (click)="onModeChange('light')"
      role="tab"
      [attr.aria-selected]="mode() === 'light'"
    >Light</button>
    <button
      type="button"
      class="delta-tab"
      [class.active]="mode() === 'dark'"
      (click)="onModeChange('dark')"
      role="tab"
      [attr.aria-selected]="mode() === 'dark'"
    >Dark</button>
  </div>

  <!-- Download diff table -->
  <div class="delta-table-wrap">
    @if (deltaRows().length === 0) {
      <p class="delta-empty">No variables found in <strong>{{ mode() }}</strong> mode.</p>
    } @else {
      <table class="delta-table" aria-label="Download theme preview">
        <caption class="sr-only">All variables in the {{ mode() }} mode theme, comparing the on-disk file with the current playground state</caption>
        <thead>
          <tr>
            <th scope="col">Key</th>
            <th scope="col">Current Json Theme</th>
            <th scope="col">Updated Theme</th>
            <th scope="col">Changes</th>
          </tr>
        </thead>
        <tbody>
          @for (row of deltaRows(); track row.variable) {
            <tr
              [class.has-change]="row.hasChange"
              [class.is-new]="row.isNew"
              [class.is-removed]="row.isRemoved"
            >
              <!-- Key -->
              <td class="delta-var-name" [title]="row.variable">{{ row.label }}</td>

              <!-- Current Json Theme (empty when variable is new) -->
              <td class="delta-value delta-current">
                @if (row.before) {
                  <span class="value-chip current-chip" [title]="row.before">
                    @if (isColor(row.before)) {
                      <span class="color-dot" [style.background]="row.before" aria-hidden="true"></span>
                    }
                    {{ row.before }}
                  </span>
                }
              </td>

              <!-- Updated Theme (playground value) -->
              <td class="delta-value delta-updated">
                @if (row.after) {
                  <span class="value-chip updated-chip" [title]="row.after">
                    @if (isColor(row.after)) {
                      <span class="color-dot" [style.background]="row.after" aria-hidden="true"></span>
                    }
                    {{ row.after }}
                  </span>
                }
              </td>

              <!-- Changes: green chip when changed, muted "--" when unchanged -->
              <td class="delta-value delta-changes">
                @if (row.hasChange) {
                  <span class="value-chip changes-chip" [title]="row.changes">
                    @if (isColor(row.changes)) {
                      <span class="color-dot" [style.background]="row.changes" aria-hidden="true"></span>
                    }
                    {{ row.changes }}
                  </span>
                } @else {
                  <span class="no-change-dash">--</span>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>

  <!-- Action buttons -->
  <div class="delta-actions">
    <button
      type="button"
      class="action-btn confirm-btn"
      (click)="onConfirm()"
    >Download</button>
    <button
      type="button"
      class="action-btn cancel-btn"
      (click)="onCancel()"
    >Cancel</button>
  </div>
</div>
